import { render, staticRenderFns } from "./interactive-editor.vue?vue&type=template&id=7fa1c6d4&scoped=true&"
import script from "./interactive-editor.vue?vue&type=script&lang=js&"
export * from "./interactive-editor.vue?vue&type=script&lang=js&"
import style0 from "./interactive-editor.vue?vue&type=style&index=0&id=7fa1c6d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa1c6d4",
  null
  
)

export default component.exports